import { render } from "./Back.vue?vue&type=template&id=6e9524f9&scoped=true"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"

import "./Back.vue?vue&type=style&index=0&id=6e9524f9&lang=scss&scoped=true"

import exportComponent from "/home/cosmic/citadel-website/citadel-landing-dao-version-citadelone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9524f9"]])

export default __exports__